import api from 'helpers/api';
import { toast } from 'sonner';

class AuthService {
  async login(user) {
    try {
      const response = await api.post('/api/v2/auth/login', user);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      localStorage.setItem('token', response.data.token);
      return { status: 'Success', message: response.data.message };
    } catch (error) {
      toast.error(error.response.data.message || 'Internal Server Error');
      return { status: 'Error' };
    }
  }

  async register(user) {
    try {
      const response = await api.post('/api/v2/auth/register', user);
      return { status: 'Success', message: response.data.message };
    } catch (error) {
      toast.error(error.response.data.message || 'Internal Server Error');
      return { status: 'Error' };
    }
  }

  async forgotPassword(email) {
    try {
      const response = await api.post('/api/v2/auth/forgot-password', email);
      return { status: 'Success', message: response.data.message };
    } catch (error) {
      toast.error(error.response.data.message || 'Internal Server Error');
      return { status: 'Error' };
    }
  }

  logout() {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
  }
}

export default new AuthService();
